import { atom } from 'jotai';

export const $FeatureFlags = atom<Record<string, unknown>>({});

$FeatureFlags.debugLabel = '$FeatureFlags';
